export default "__VITE_ASSET__DUhIzpfD__"